import React, { useEffect, useState } from 'react'
import { Container, Nav } from 'react-bootstrap'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import FooterNew from '../components/Footer'
import { Link } from 'react-router-dom'
import StepperComponent from '../components/stepper/StepperComponent'
import { Trans, useTranslation } from 'react-i18next'
const postStep1 = '/stepperVideos/postCreation/step1.mp4'
const postStep2 = '/stepperVideos/postCreation/step2.mp4'
const postStep3 = '/stepperVideos/postCreation/step3.mp4'
const auctionStep1 = '/stepperVideos/auctionCreation/step1.mp4'
const auctionStep2 = '/stepperVideos/auctionCreation/step2.mp4'
const auctionStep3 = '/stepperVideos/auctionCreation/step3.mp4'
const auctionStep4 = '/stepperVideos/auctionCreation/step4.mp4'

const Faq = () => {
  const [activeItems, setActiveItems] = useState<string[]>([])
  const [modalType, setModalType] = useState<string | null>(null)
  const { t } = useTranslation()
  const handleOpenModal = (type: string) => {
    setModalType(type)
  }

  const handleCloseModal = () => {
    setModalType(null)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const postStepper = [
    { video: postStep1 },
    {
      video: postStep2,
      description: 'Insert your information of the residence.',
    },
    {
      video: postStep3,
      description: 'Insert your information of the residence.',
    },
  ]

  const auctionStepper = [
    { video: auctionStep1, description: 'Create a post with the category `Auction` .' },
    {
      video: auctionStep2,
    },
    {
      video: auctionStep3,
    },
    {
      video: auctionStep4,
    },
  ]

  const handleItemClick = (uniqueId: string) => {
    setActiveItems((prevActiveItems) => {
      if (prevActiveItems.includes(uniqueId)) {
        return prevActiveItems.filter((id) => id !== uniqueId)
      } else {
        return [...prevActiveItems, uniqueId]
      }
    })
  }

  const items = [
    {
      category: t('faq_page.details.section_1.title'),
      questions: [
        {
          title: t('faq_page.details.section_1.items.question_1'),
          description: t('faq_page.details.section_1.items.answer_1'),
        },
        {
          title: t('faq_page.details.section_1.items.question_2'),
          description: t('faq_page.details.section_1.items.answer_2'),
        },
        {
          title: t('faq_page.details.section_1.items.question_3'),
          description: t('faq_page.details.section_1.items.answer_3'),
        },
        {
          title: t('faq_page.details.section_1.items.question_4'),
          description: (
            <Trans
              i18nKey='faq_page.details.section_1.items.answer_4'
              components={{ 1: <Nav.Link className='pl-1 d-inline' as={Link} to='/login' /> }}
            />
          ),
        },
      ],
    },
    {
      category: t('faq_page.details.section_2.title'),
      questions: [
        {
          title: t('faq_page.details.section_2.items.question_1'),
          description: (
            <button className='add-post-button' onClick={() => handleOpenModal('post')}>
              {t('faq_page.list_property')}
            </button>
          ),
        },
        {
          title: t('faq_page.details.section_2.items.question_2'),
          description: t('faq_page.details.section_2.items.answer_2'),
        },
        {
          title: t('faq_page.details.section_2.items.question_3'),
          description: t('faq_page.details.section_2.items.answer_3'),
        },
      ],
    },
    {
      category: t('faq_page.details.section_3.title'),
      questions: [
        {
          title: t('faq_page.details.section_3.items.question_1'),
          description: t('faq_page.details.section_3.items.answer_1'),
        },
        {
          title: t('faq_page.details.section_3.items.question_2'),
          description: t('faq_page.details.section_3.items.answer_2'),
        },
        {
          title: t('faq_page.details.section_3.items.question_3'),
          description: t('faq_page.details.section_3.items.answer_3'),
        },
        {
          title: t('faq_page.details.section_3.items.question_4'),
          description: (
            <button className='add-post-button' onClick={() => handleOpenModal('auction')}>
              {t('faq_page.list_auction')}
            </button>
          ),
        },
        {
          title: t('faq_page.details.section_3.items.question_5'),
          description: t('faq_page.details.section_3.items.answer_5'),
        },
      ],
    },
    {
      category: t('faq_page.details.section_4.title'),
      questions: [
        {
          title: t('faq_page.details.section_4.items.question_1'),
          description: t('faq_page.details.section_4.items.answer_1'),
        },
        {
          title: t('faq_page.details.section_4.items.question_2'),
          description: t('faq_page.details.section_4.items.answer_2'),
        },
        {
          title: t('faq_page.details.section_4.items.question_3'),
          description: t('faq_page.details.section_4.items.answer_3'),
        },
        {
          title: t('faq_page.details.section_4.items.question_4'),
          description: t('faq_page.details.section_4.items.answer_4'),
        },
        {
          title: t('faq_page.details.section_4.items.question_5'),
          description: t('faq_page.details.section_4.items.answer_5'),
        },
        {
          title: t('faq_page.details.section_4.items.question_6'),
          description: t('faq_page.details.section_4.items.answer_6'),
        },
        {
          title: t('faq_page.details.section_4.items.question_7'),
          description: t('faq_page.details.section_4.items.answer_7'),
        },
        {
          title: t('faq_page.details.section_4.items.question_8'),
          description: t('faq_page.details.section_4.items.answer_8'),
        },
        {
          title: t('faq_page.details.section_4.items.question_9'),
          description: t('faq_page.details.section_4.items.answer_9'),
        },
        {
          title: t('faq_page.details.section_4.items.question_10'),
          description: t('faq_page.details.section_4.items.answer_10'),
        },
        {
          title: t('faq_page.details.section_4.items.question_11'),
          description: t('faq_page.details.section_4.items.answer_11'),
        },
        {
          title: t('faq_page.details.section_4.items.question_12'),
          description: t('faq_page.details.section_4.items.answer_12'),
        },
        {
          title: t('faq_page.details.section_4.items.question_13'),
          description: t('faq_page.details.section_4.items.answer_13'),
        },
        {
          title: t('faq_page.details.section_4.items.question_14'),
          description: t('faq_page.details.section_4.items.answer_14'),
        },
        {
          title: t('faq_page.details.section_4.items.question_15'),
          description: t('faq_page.details.section_4.items.answer_15'),
        },
        {
          title: t('faq_page.details.section_4.items.question_16'),
          description: t('faq_page.details.section_4.items.answer_16'),
        },
        {
          title: t('faq_page.details.section_4.items.question_17'),
          description: t('faq_page.details.section_4.items.answer_17'),
        },
      ],
    },
  ]

  return (
    <>
      <Container>
        <h1 className='text-center pt-5 pricing-header-2'>{t('faq_page.page_title')}</h1>
        <div className='pb-5 pt-2'>
          {items.map((category, categoryIndex) => (
            <div key={categoryIndex} className='category-container'>
              <h2 className='pricing-header-1 ms-1 pt-3'>{category.category}:</h2>
              {category.questions.map((item, featureIndex) => {
                const uniqueId = `${categoryIndex}-${featureIndex}`
                return (
                  <div key={uniqueId} className='collapsible-item'>
                    <div
                      className={`feature-title ${activeItems.includes(uniqueId) ? 'expanded' : ''}`}
                      onClick={() => handleItemClick(uniqueId)}
                    >
                      {item.title}
                      {activeItems.includes(uniqueId) ? (
                        <FaAngleUp className='text-danger' />
                      ) : (
                        <FaAngleDown className='greenColor' />
                      )}
                    </div>
                    {activeItems.includes(uniqueId) && (
                      <div className='description'>
                        <div className='pb-3'>{item.description}</div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </Container>
      <FooterNew />

      {modalType === 'post' && (
        <StepperComponent
          title='Post Creation'
          info={postStepper}
          isOpen={true}
          handleClose={handleCloseModal}
        />
      )}

      {modalType === 'auction' && (
        <StepperComponent
          title='Auction Creation'
          info={auctionStepper}
          isOpen={true}
          handleClose={handleCloseModal}
        />
      )}
    </>
  )
}

export default Faq
